// Wrapper fino sobre clsx. Mantém import único pra trocar de lib se preciso.
import clsx, { type ClassValue } from 'clsx';

export function cn(...values: ClassValue[]): string {
  return clsx(values);
}
